import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import GradientButton from './GradientButton';
import CountdownTimer from './CountdownTimer';
import AIAnimationCanvas from './AIAnimationCanvas';
const HeroSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const handleGetInNow = () => {
    navigate('/nocode/onboarding');
  };
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100');
          entry.target.classList.remove('opacity-0', 'translate-y-10');
        }
      });
    }, {
      threshold: 0.1
    });
    const elements = document.querySelectorAll('.animate-on-scroll');
    elements.forEach(el => observer.observe(el));
    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, []);
  return <section ref={sectionRef} className="relative min-h-screen flex items-center pt-20 pb-16 w-full overflow-hidden bg-black">
      {/* Black background */}
      {/* AI Animation Background */}
      <div className="absolute inset-0 w-full h-full opacity-20">
        <AIAnimationCanvas />
      </div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="mb-6">
            <span className="inline-block bg-white/10 backdrop-blur-sm text-white font-montserrat px-4 py-2 rounded-full text-sm sm:text-base mb-4">Build it! Launch it! Own it!</span>
            
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-montserrat font-bold text-white leading-tight mb-6">
              I'll Show You How to <span className="text-yellow-400">Build, Launch, and Own</span> a Web App, Website, Landing Page, or SaaS with AI in Just a Few Minutes!
            </h1>
            
            <p className="text-xl sm:text-2xl text-purple-100 mb-8">
              No code required—if my grandmother can build her online safe box, so can you!
            </p>
          </motion.div>
          
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="mb-10">
            <GradientButton onClick={handleGetInNow} className="text-lg sm:text-xl py-4 px-8 sm:px-12">
              Get In Now
            </GradientButton>
            
            <p className="mt-4 text-purple-200 font-medium flex justify-center items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
              </svg>
              Limited Spots Available – Act Fast
            </p>
          </motion.div>
          
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="max-w-md mx-auto">
            <p className="text-purple-200 mb-2">There is no limit to what you can build with AI</p>
            <CountdownTimer hours={24} />
          </motion.div>
          
          {/* Scroll indicator */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1,
          duration: 1
        }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center">
            
            <svg className="w-6 h-6 text-purple-200 animate-bounce" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
              <path d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default HeroSection;